import clsx from 'clsx';
import { Close } from '@/components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Header = ({
  name,
  message,
  type,
  onClose,
  hasCloseButton
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "ima-header",
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx('ima-header__type', `ima-header__type--${type}`),
      children: type ? `${type} error` : 'Error'
    }), /*#__PURE__*/_jsxs("div", {
      className: "ima-header__meta",
      children: [/*#__PURE__*/_jsxs("span", {
        className: "ima-header__name",
        children: [name, ": "]
      }), /*#__PURE__*/_jsx("span", {
        className: "ima-header__message",
        children: message
      })]
    }), hasCloseButton && /*#__PURE__*/_jsx(Close, {
      onClose: () => onClose()
    })]
  });
};
export default Header;